import api from "./base-api"

const personalDataApi = api.injectEndpoints({
    endpoints: (build) => ({
        getThanosProjects: build.query({
            query: () => `v1/thanos/projects`
        }),
        searchPersonalData: build.mutation({
            query: (body) => ({
                url: `v1/personal-data/search`,
                method: "POST",
                body
            })
        }),
        erasePersonalData: build.mutation({
            query: (body) => ({
                url: `v1/personal-data/erase`,
                method: "POST",
                body
            })
        })
    }),
    overrideExisting: false
})

export const {
    useGetThanosProjectsQuery,
    useSearchPersonalDataMutation,
    useErasePersonalDataMutation
} = personalDataApi
